import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function AdminAnalytics() {
  const { t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-white/60">{t.common.loading}</div>;

  const cards = [
    { label: "Total ambassadors", value: data.total_ambassadors },
    { label: "Active ambassadors", value: data.active_ambassadors },
    { label: "Total referrals", value: data.total_referrals },
    { label: "Consultations", value: data.consultations },
    { label: "Treatments", value: data.treatments },
    { label: "Qualified referrals", value: data.qualified },
    { label: "Conversion rate", value: `${data.conversion_rate}%` },
    { label: "Est. revenue / ambassador", value: `£${data.estimated_revenue_per_ambassador}` },
    { label: "Rewards paid (£)", value: `£${data.rewards_paid}` },
    { label: "Rewards pending (£)", value: `£${data.rewards_pending}` },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif-display text-4xl">{t.admin.analytics}</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} data-testid={`analytics-${c.label.replace(/\s+/g, "-").toLowerCase()}`} className="rounded-2xl bg-white/5 border border-white/10 p-5">
            <div className="text-xs uppercase tracking-widest text-white/50">{c.label}</div>
            <div className="font-serif-display text-3xl mt-2 text-[#f4a261]">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
        <div className="text-xs uppercase tracking-widest text-white/50">Best channel</div>
        <div className="mt-3 flex gap-6">
          {Object.entries(data.channel_breakdown).map(([k, v]) => (
            <div key={k}>
              <div className="text-xs uppercase tracking-widest text-white/50">{k}</div>
              <div className="font-serif-display text-2xl text-white">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
